import ChatSpace from './chat_space';
import {
  get_date_from_now,
  mark_message_read,
  get_time,
  get_avatar_html,
  set_notification_count,
} from './chat_utils';
import { 
  collection, doc, getDoc, getDocs, addDoc, setDoc, 
  updateDoc, query, orderBy, serverTimestamp,
  onSnapshot, where, deleteDoc
} from 'firebase/firestore';
import * as unreadFix from './unread_fix';

export default class ChatRoom {
  constructor(opts) {
    this.$wrapper = opts.$wrapper;
    this.$chat_rooms_container = opts.$chat_rooms_container;
    this.chat_list = opts.chat_list;
    this.profile = opts.element;
    this.setup();
    
    // Check if this room is already marked as read in current session
    const isReadInLocalStorage = frappe.Chat.settings.read_rooms && 
                                frappe.Chat.settings.read_rooms[this.profile.room];
                                
    // Override profile's is_read if it's already read in localStorage
    if (isReadInLocalStorage) {
      this.profile.is_read = true;
    }
    
    // Only increment the unread count if it's unread and not already counted
    if (!this.profile.is_read) {
      set_notification_count('increment');
    }
  }

  setup() {
    this.$chat_room = $(document.createElement('div'));
    this.$chat_room.addClass('chat-room');

    this.avatar_html = get_avatar_html(
      this.profile.room_type,
      this.profile.opposite_person_email,
      this.profile.room_name
    );

    let last_message = this.sanitize_last_message(this.profile.last_message);

    const info_html = `
      <div class='chat-profile-info'>
        <div class='chat-name'>
          ${__(this.profile.room_name)} 
          ${this.profile.room_type === 'Group' ? `
            <div class="remove-room" title="Delete Group">
              ${frappe.utils.icon('delete', 'sm')}
            </div>
          ` : ''}
          <div class='chat-latest' 
            style='display: ${this.profile.is_read ? 'none' : 'inline-block'}'
          ></div>
        </div>
        <div style='color: ${
          this.profile.is_read ? 'var(--text-muted)' : 'var(--text-color)'
        }' class='last-message'>${__(last_message)}</div>
      </div>
    `;
    const date_html = `
      <div class='chat-date'>
        ${__(get_date_from_now(this.profile.last_date, 'room'))}
      </div>
    `;
    let inner_html = '';

    inner_html += this.avatar_html + info_html + date_html;

    this.$chat_room.html(inner_html);
    this.setup_styles();
  }

  sanitize_last_message(message) {
    let sanitize_last_message = $('<div>').text(message).html();
    if (sanitize_last_message) {
      if (sanitize_last_message.length > 20) {
        sanitize_last_message = sanitize_last_message.substring(0, 20) + '...';
      }
    }
    return sanitize_last_message;
  }

  set_as_read() {
    // Only mark as read and decrement count if it's not already read
    if (!this.profile.is_read) {
      this.$chat_room.find('.chat-latest').hide();
      this.$chat_room.find('.last-message').css('color', 'var(--text-muted)');
      set_notification_count('decrement');
      this.profile.is_read = true;
    } else {
      // If already read, just reset for this room
      set_notification_count('reset', this.profile.room);
    }
  }

  update_last_message(message) {
    const displayMessage = message.length > 24 ? message.substring(0, 24) + '...' : message;
    this.set_last_message(displayMessage, new Date().toISOString());
    
    if ($('.chat-list').length) {
      this.set_as_unread();
      this.move_to_top();
      this.chat_list.move_room_to_top([this.profile.room, this]);
    } else if ($('.chat-space').length) {
      mark_message_read(this.profile.room);
    }
    
    // Play notification sound if enabled and chat isn't visible
    if (
      !$('.chat-element').is(':visible') &&
      frappe.Chat.settings.user.enable_notifications === 1
    ) {
      frappe.utils.play_sound('chat-notification');
    }
  }

  set_last_message(message, date) {
    this.$chat_room.find('.last-message').text(__(message));
    this.$chat_room
      .find('.chat-date')
      .text(__(get_date_from_now(date, 'room')));
  }

  set_as_unread() {
    // Only increment notification count if not already unread
    if (this.profile.is_read) {
      this.$chat_room.find('.chat-latest').show();
      this.$chat_room.find('.last-message').css('color', 'var(--text-color)');
      
      // Update the unread count
      set_notification_count('increment');
      
      // Mark room as unread
      this.profile.is_read = false;
      
      // Remove this room from read_rooms tracking
      if (frappe.Chat.settings.read_rooms && frappe.Chat.settings.read_rooms[this.profile.room]) {
        delete frappe.Chat.settings.read_rooms[this.profile.room];
        // Save updated read rooms to localStorage
        localStorage.setItem('chat_read_rooms', JSON.stringify(frappe.Chat.settings.read_rooms));
      }
    }
  }

  render(mode) {
    if (mode == 'append') {
      this.$chat_rooms_container.append(this.$chat_room);
    } else {
      this.$chat_rooms_container.prepend(this.$chat_room);
    }

    this.setup_events();
  }

  move_to_top() {
    $(this.$chat_room).prependTo(this.$chat_rooms_container);
  }

  setup_events() {
    const me = this;

    // Use event delegation for click handling since elements might be dynamically added
    this.$chat_room.off('click').on('click', function () {
      $('.chat-room').removeClass('active');
      $(this).addClass('active');
      
      // Create a new chat space for this room
      me.chat_space = new ChatSpace({
        $wrapper: me.$wrapper,
        profile: {
          user: me.profile.user,
          user_email: me.profile.user_email,
          room: me.profile.room,
          room_name: me.profile.room_name,
          room_type: me.profile.room_type,
          last_message: me.profile.last_message,
          last_date: me.profile.last_date,
          is_admin: me.profile.is_admin,
          opposite_person_email: me.profile.opposite_person_email,
        },
        chat_list: me.chat_list,
      });
      
      // Only mark as read if it wasn't already read
      if (!me.profile.is_read) {
        console.log(`Marking room ${me.profile.room} as read (was unread)`);
        
        // Mark messages as read in Firebase
        mark_message_read(me.profile.room);
        
        // Update UI
        me.set_as_read();
      } else {
        console.log(`Room ${me.profile.room} was already read - no change to unread count`);
        
        // Still ensure it's marked as read in localStorage via reset
        set_notification_count('reset', me.profile.room);
      }
    });

    // Handle room deletion separately
    if (this.profile.room_type === 'Group') {
      this.$chat_room.find('.remove-room').off('click').on('click', function (e) {
        e.stopPropagation();
        frappe.confirm(
          __(`Are you sure you want to delete the room "${me.profile.room_name}"?`),
          async () => {
            try {
              // Create deletion record in Firestore
              const deletionRef = doc(frappe.firebase.db, 'room_deletions', me.profile.room);
              await setDoc(deletionRef, {
                deleted_by: frappe.session.user,
                deleted_at: serverTimestamp(),
                room_name: me.profile.room_name
              });
              
              // Remove room from UI
              me.$chat_room.remove();
              
              // Remove from chat_rooms array
              const indexToRemove = me.chat_list.chat_rooms.findIndex(
                (item) => item[0] === me.profile.room
              );
              if (indexToRemove !== -1) {
                me.chat_list.chat_rooms.splice(indexToRemove, 1);
              }
              
              // Show success message
              frappe.show_alert({
                message: __('Room deleted successfully'),
                indicator: 'green'
              });
              
              // Also update in Frappe backend
              await frappe.call({
                method: 'chat.api.room.delete',
                args: {
                  room: me.profile.room,
                },
              });
            } catch (error) {
              console.error('Error deleting room:', error);
              frappe.show_alert({
                message: __('Failed to delete room'),
                indicator: 'red'
              });
            }
          }
        );
      });
    }
  }

  setup_styles() {
    const style = document.createElement('style');
    style.textContent = `
      .chat-name {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .remove-room {
        cursor: pointer;
        padding: 4px;
        color: var(--gray-500);
        visibility: hidden;
      }
      .remove-room:hover {
        color: var(--red-500);
      }
      .chat-room:hover .remove-room {
        visibility: visible;
      }
    `;
    document.head.appendChild(style);
  }
}
